// extracted by mini-css-extract-plugin
export default {"cls1":"RemovedItemNotice-cls1___cfafbbae32f1ec6f2e3","cls2":"RemovedItemNotice-cls2___68db0b46b2aa35e13fc RemovedItemNotice-cls1___cfafbbae32f1ec6f2e3"};